import { useLayoutEffect, useState } from "react";

export const useStageDimensions = ({
  containerRef,
  compositionWidth,
  compositionHeight,
  reservedBottom = 0,
}) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const compute = () => {
      const parent = containerRef.current;
      if (!parent || !compositionWidth || !compositionHeight) {
        return;
      }

      const parentWidth = parent.clientWidth;
      const parentHeight = parent.clientHeight;
      if (!parentWidth || !parentHeight) {
        return;
      }

      const aspect = compositionWidth / compositionHeight;
      const availableHeight = Math.max(0, parentHeight - reservedBottom);
      let width = parentWidth;
      let height = width / aspect;

      if (height > availableHeight) {
        height = availableHeight;
        width = height * aspect;
      }

      setDimensions({
        width: Math.max(0, Math.floor(width)),
        height: Math.max(0, Math.floor(height)),
      });
    };

    compute();

    const observer =
      typeof ResizeObserver === "undefined"
        ? null
        : new ResizeObserver(compute);

    if (containerRef.current) {
      observer?.observe(containerRef.current);
    }

    window.addEventListener("resize", compute);

    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", compute);
    };
  }, [compositionHeight, compositionWidth, containerRef, reservedBottom]);

  return dimensions;
};
